module.exports = __webpack_public_path__ + "img/9788959522309.92818aa0.jpg";